import { c as _c } from "react/compiler-runtime";
import React from "react";
export const WaveLeaderboardLoadingBar: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-w-full tw-h-0.5 tw-bg-iron-800 tw-overflow-hidden"><div className="tw-w-full tw-h-full tw-bg-indigo-400 tw-animate-loading-bar" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};